import FamilyMemberItem from './FamilyMemberItem.js';

export default FamilyMemberItem;



// WEBPACK FOOTER //
// ./src/components/Pages/Family/FamilyMemberItem/index.js